import { Client } from '../react-app-env'
import { UidCompany, UidLocalSnapshot } from '../types/uid.type'

function normalise(v: string | null | undefined): string {
  return (v ?? '').trim().toLowerCase()
}

function compareValues(
  local: string,
  uid: string | null | undefined
): 'match' | 'mismatch' | 'unknown' {
  if (!local.trim() || !(uid ?? '').trim()) return 'unknown'
  return normalise(local) === normalise(uid) ? 'match' : 'mismatch'
}

function uidPublicStatusToLocal(status: number | null | undefined): string {
  return status === 1 ? 'active' : 'inactive'
}

function localSnapshotFromClient(client: Client): UidLocalSnapshot {
  return {
    name: client.name ?? '',
    legalForm: client.stammdaten?.legal_form ?? '',
    city: client.stammdaten?.address?.[0]?.city ?? '',
    canton: '',
    status: client.status === 'inactive' ? 'inactive' : 'active',
  }
}

export function computeUidCheckVariant(
  clientOrSnapshot: Client | UidLocalSnapshot,
  data: UidCompany
): 'success' | 'warning' | 'danger' {
  const snapshot: UidLocalSnapshot =
    data.localSnapshot ??
    (isClient(clientOrSnapshot) ? localSnapshotFromClient(clientOrSnapshot) : clientOrSnapshot)

  const uidStatus = uidPublicStatusToLocal(data?.uidregInformation?.uidregPublicStatus)

  const results = [
    compareValues(snapshot.name, data.organisationName ?? data.organisationLegalName),
    compareValues(snapshot.legalForm, data.legalForm),
    compareValues(snapshot.city, data.address?.town),
    compareValues(snapshot.canton, data.address?.cantonAbbreviation),
    compareValues(snapshot.status, uidStatus),
  ]

  const hasFailed = results.filter(val => val === 'mismatch').length > 1
  if (hasFailed) return 'danger'
  if (results.some(r => r === 'unknown')) return 'warning'
  return 'success'
}

function isClient(obj: Client | UidLocalSnapshot): obj is Client {
  return '_id' in obj
}
